var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('h1',[_vm._v("Error")]),_c('h1',[_vm._v("This page does not exist 💀")])])
}]

export { render, staticRenderFns }